import React, { useState } from "react";
import { mapTableRows } from "../../../../utils";
import { Backdrop, FormFieldSet, LogoLoader, StatusTags, TableAdv } from "../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getTeamProspectsCountStart, getTeamProspectsStart } from "../../../../redux/slices/leads/leadsSlice";
import { usePagination } from "../../../../hooks";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { formatWords2 } from "../../../../utils/stringUtils";
import { getEndOfDay, getStartOfDay } from "../../../../utils/common";
const MyTeamProspects = () => {
  const { userData: loginUserData } = useLoginUser();
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { }
  );

  const dispatch = useDispatch();
  // const [fromDate, setFromDate] = useState(convertToUTC(dayjs().startOf("day").format("YYYY-MM-DD HH:mm")));
  const [fromDate, setFromDate] = useState(
    new Date()
  );
  // const [toDate, setToDate] = useState(convertToUTC(dayjs().endOf("day").format("YYYY-MM-DD HH:mm")));
  const [toDate, setToDate] = useState(
    new Date()
  );
  const prospectsData = useSelector(
    (state) => state.leads?.teamProspects?.data || []
  );
  const loading = useSelector(
    (state) => state.leads?.loading
  );
  const [jobStatus, setJobStatus] = useState([]);
  const totalCount = useSelector(
    (state) => state.leads?.teamProspects?.total || 0
  );
  // console.log(prospectsData, "prospectsData");
  const userRoleType = loginUserData?.role?.type;
  const columns = [
    {
      key: "pId",
      label: "ID",
      render: (row) => <div className="text-info">{row.id}</div>,
    },
    {
      key: "raName",
      label: "RA Name",
      width: "min-w-[180px]! max-w-[250px]!"
    },
    {
      key: "clientName",
      label: "Client Name",
      width: "min-w-[200px]! max-w-[250px]!"
    },
    {
      key: "jobPosition",
      label: "Job Position",
      width: "min-w-[250px]! max-w-[300px]!"
    },
    {
      key: "jobLocation",
      label: "Job Location",
      width: "min-w-[200px]! max-w-[250px]!"
    },
    {
      key: "bdmName",
      label: "BDM Name",
      width: "min-w-[200px]! max-w-[250px]!"
    },
    {
      key: "bdmResponseDate",
      label: "BDM Response Date",
      width: "min-w-[200px]! max-w-[250px]!"
    },
    {
      key: "leadDate",
      label: "Lead Date",
      width: "min-w-[200px]! max-w-[250px]!"
    },
    {
      key: "jobStatus",
      label: "Job Status",
      render: (row) => {
        return (<StatusTags tag={row.jobStatus} className={row.jobStatus === "Closed" ? " !bg-danger-500 text-white" : "bg-success-500 text-white"} />)
      }
    },
  ];

  const rows = Array.from({ length: 9 }, (_, index) => ({
    id: index + 1,
    pId: "NESU-070725",
    raName: "Ershad",
    clientName: "Sajida",
    jobPosition: "Assistant Manager",
    jobLocation: "Dallas, USA",
    bdmName: "Ershad",
    bdmResponseDate: "Sept 07, 2025",
    leadDate: "Sept 26, 2025",
    jobStatus: "Active",
  }));
  // const mappedRows = mapTableRows(rows, columns);

  const JobStatus = {
    1: "Active",
    2: "Positive",
    3: "Open",
    4: "On Hold", // job posting status
    5: "Hold by Client",
    6: "Interview L1",
    7: "Interview L2",
    8: "Interview L3",
    9: "Priority",
    10: "Filled",
    11: "Closed",
    12: "Agreement Sent",
    13: "Agreement Accepted",
  };

  let counter = 1;
  const rowss = [];
  (prospectsData || []).forEach((item, prospectIndex) => {
    const raName = item.addedBy?.firstName || "";
    const bdmName = item.modifiedBy?.firstName || "";
    const bdmResponseDate = convertFromUTC(item?.modifiedOn) || "";
    rowss.push({
      id: counter++,
      // raName,
      raName: formatWords2(raName),
      clientName: formatWords2(item?.companyId?.name) || "",
      jobPosition: formatWords2(item?.title) || "",
      jobLocation: [
        item?.location?.city,
        item?.location?.state,
        item?.location?.country
      ]
        .filter(Boolean)
        .join(", "),
      // bdmName,
      bdmName: formatWords2(bdmName),
      bdmResponseDate,
      leadDate: convertFromUTC(item?.addedOn),
      jobStatus: JobStatus[item?.status] || "Unknown",
    });
  });
  const mappedRows = mapTableRows(rowss, columns);




  useEffect(() => {
    const filters = {
      dates: {
        type: "AG_TEAM_PROSPECTS",
        value: [
          // fromDate ? dayjs(fromDate).startOf("day").toISOString() : "",
          // toDate ? dayjs(toDate).endOf("day").toISOString() : "",
          fromDate ? getStartOfDay(fromDate) : "",
          toDate ? getEndOfDay(toDate) : "",
        ],
        userId: loginUserData?.uiid,
        // userId: 63,
      }
    };
    if (jobStatus && jobStatus.length > 0) {
      filters.status = {
        type: "IN",
        value: jobStatus,
      };
    }
    const action = {
      coll: "Job",
      lim: limit,
      pg: page,
      ret: "uiid title addedBy addedOn companyId location status description modifiedBy modifiedOn",
      ref: "Company",
      fil: JSON.stringify(filters),
      // extret: "uiid firstName",
      incl: ["name"],
      queryMode: "AG_TEAM_PROSPECTS",
      extret: "uiid firstName",
      sort: JSON.stringify({ modifiedOn: -1 }),
    };
    const actioncount = {
      coll: "Job",
      lim: limit,
      pg: page,
      ret: "uiid title addedBy addedOn companyId location status description modifiedBy modifiedOn",
      ref: "Company",
      fil: JSON.stringify(filters),
      // extret: "uiid firstName",
      incl: ["name"],
      queryMode: "AG_TEAM_PROSPECTS_COUNT",
      extret: "uiid firstName",
      sort: JSON.stringify({ modifiedOn: -1 }),
    };
    dispatch(getTeamProspectsStart(action));
    dispatch(getTeamProspectsCountStart(actioncount));
  }, [dispatch, page, limit, fromDate, toDate, jobStatus]);

  return (
    <div className="flex-1 overflow-auto shadow-tableset">
      <TableAdv
        tableId={"RAMyTeamProspectsTable"}
        showCheckbox
        columns={columns}
        rows={mappedRows}
        serverPagination={true}
        totalCount={typeof totalCount === "number" ? totalCount : 0}
        page={page}
        limit={limit}
        onPageChange={setPage}
        onLimitChange={handleLimitChange}
        info={"info"}
        tdClassName="!py-3"
        toolbarRight={{
          filter: true,
          add: [
            {
              component: (
                <>
                  <FormFieldSet
                    noTitle
                    placeholder="Select date range"
                    type="datepickerRange"
                    size="sm"
                    value={{
                      from: fromDate,
                      to: toDate,
                    }}
                    onChange={(range) => {
                      if (range?.from && range?.to) {
                        setFromDate(range?.from || null);
                        setToDate(range?.to || null);
                      }
                    }}
                  />
                  <div className="min-w-[200px]">
                    <FormFieldSet
                      type="select"
                      placeholder="Select"
                      noTitle
                      size="sm"
                      multiple
                      options={[
                        { label: "Active", value: 1 },
                        { label: "Positive", value: 2 },
                        { label: "Open", value: 3 },
                        { label: "On Hold", value: 4 },
                        { label: "Hold by Client", value: 5 },
                        { label: "Interview L1", value: 6 },
                        { label: "Interview L2", value: 7 },
                        { label: "Interview L3", value: 8 },
                        { label: "Priority", value: 9 },
                        { label: "Filled", value: 10 },
                        { label: "Closed", value: 11 },
                        { label: "Agreement Sent", value: 12 },
                        { label: "Agreement Accepted", value: 13 },
                      ]}
                      value={jobStatus}
                      onChange={(value) => setJobStatus(value)}
                    />
                  </div>
                </>
              ),
            },
          ],
          order: ["add", "filter"],
        }}
      />
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default MyTeamProspects;
